import { SystemStyleObject, Theme } from '@mui/system';

import { FONT_FAMILY } from '@/shared/ui/form-fields/fieldStyles';

/**
 * One text style across the Drive dialogs, sized per role: the design system's Heading/Body ramp over
 * `Typography/h-secondary` (grey.900) and `Typography/p-tertiary` (grey.600). `fieldLabel`, `fieldText` and
 * `tableHeader` instead mirror the platform's form fields and the bookings grid header, so the dialog reads
 * like both. Every entry names the family, the way `FORM_LABEL_SX` and the grid's own header rule do.

 */
export const driveDialogText: Record<
  | 'title'
  | 'section'
  | 'strong'
  | 'primary'
  | 'secondary'
  | 'fieldLabel'
  | 'fieldText'
  | 'tableHeader',
  SystemStyleObject<Theme>
> = {
  title: {
    fontFamily: FONT_FAMILY,
    color: 'grey.900',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 1.25,
  },
  section: {
    fontFamily: FONT_FAMILY,
    color: 'grey.900',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.25,
  },
  strong: {
    fontFamily: FONT_FAMILY,
    color: 'grey.900',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.25,
  },
  primary: {
    fontFamily: FONT_FAMILY,
    color: 'grey.900',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.25,
  },
  secondary: {
    fontFamily: FONT_FAMILY,
    color: 'grey.600',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.25,
  },
  fieldLabel: {
    fontFamily: FONT_FAMILY,
    color: 'grey.950',
    fontSize: '14px',
    fontWeight: 350,
    lineHeight: 1.3,
  },
  fieldText: {
    fontFamily: FONT_FAMILY,
    color: 'grey.950',
    fontSize: '14px',
    fontWeight: 350,
    lineHeight: 1.3,
  },
  tableHeader: {
    fontFamily: FONT_FAMILY,
    color: 'grey.800',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
};
